import { render, staticRenderFns } from "./OrganizationChildren.vue?vue&type=template&id=cf17ba66"
import script from "./OrganizationChildren.vue?vue&type=script&lang=js"
export * from "./OrganizationChildren.vue?vue&type=script&lang=js"
import style0 from "./OrganizationChildren.vue?vue&type=style&index=0&id=cf17ba66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports